Auth = require 'app/scripts/db/auth'
ColorsView = require './change-board-background-colors-component-view'
PhotosView = require './change-board-background-photos-component-view'
Backgrounds = require 'app/scripts/data/backgrounds'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
View = require 'app/scripts/views/internal/view'
xtend = require 'xtend'
{ unsplashClient } = require '@trello/unsplash'

Component =
  colors: ColorsView
  photos: PhotosView

# Get background prefs
getBackgroundPrefs = (prefs) ->
  out = {}
  for key, value of prefs
    if key.indexOf('background') > -1
      out[key] = value
  out

module.exports = class BoardBackgroundSelectView extends View
  viewTitleKey: ->
    if @options.component == 'colors'
      'change background colors'
    else
      'change background photos'

  viewTitleArguments: {
    unsplashUrl: unsplashClient.attributionUrl
  }

  className: 'board-menu-content-frame'

  initialize: ->
    @listenTo @model, 'change:prefs.background change:prefs.backgroundTile change:prefs.backgroundBrightness', @frameDebounce @render
    @listenTo @model.viewState, 'change:boardBackgroundPromptOpenedSidebar', @frameDebounce @render
    return

  render: ->
    props =
      boardId: @model.id
      backgroundPrefs: getBackgroundPrefs @model.attributes.prefs

    if @options.component == 'colors'
      props.setBackgroundColor = (name, color) =>
        @model
          .set
            prefs: xtend @model.get('prefs'),
              background: name
              backgroundColor: color
              backgroundImage: null
              backgroundImageScaled: null
          .setPref 'background', name
        Auth.me().dismiss('board-background-prompt')

    if @model.viewState.get('boardBackgroundPromptOpenedSidebar')
      props.cancelable = true
      props.onCancel = =>
        background = @model.viewState.get('initialBackgroundColor') || 'blue'
        @model
          .set
            prefs:
              background: background
              backgroundColor: Backgrounds[background].color
              backgroundBrightness: Backgrounds[background].brightness
              backgroundImage: null
              backgroundImageScaled: null
          .setPref 'background', background
        @model.viewState.set('boardBackgroundPromptOpenedSidebar', false)
        @model.viewState.set('showSidebar', false)
        @model.viewState.set('showBoardBackgroundPromptPopover', true)
        Auth.me().dismiss('board-background-prompt')

    Element = React.createElement(Component[@options.component], props)

    ReactDOM.render(Element, @el)

    @
